
























import { Vue, Component } from 'vue-property-decorator';

import UpdateIdentityDocumentLoadingPageViewModel
  from '@/vue-app/view-models/components/update-identity-document/update-identity-document-loading-page-view-model';

@Component({
  name: 'UpdateIdentityDocumentLoadingPage',
})
export default class UpdateIdentityDocumentLoadingPage extends Vue {
  view_model = new UpdateIdentityDocumentLoadingPageViewModel();
}

